
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { isValidUsername } from '@/utils/validate'
import { UserModule } from '@/store/modules/user'
import LangSelect from '@/components/LangSelect/index.vue'
// import { getCaptcha } from '@/api/user'
import { captcha } from '@/api/types'
import { getType } from '@/utils/cookies'
import { log } from 'console'

@Component({
  name: 'Login',
  components: {
    LangSelect
  }
})
export default class extends Vue {
  get isMobileH5() {
    return window.screen.availWidth <= 700 && window.screen.availWidth >= 310
  }
  private dialogVisible: boolean = false
  private currentDomain: any = ''
  private jumpDoain: string = ''
  // private enterpriseType: string = ''
  // private enterpriseType: string = 'payment'

  // @Watch('enterpriseType', { immediate: true })
  // private changeEnterpriseType(val) {
  //   this.loginForm.code = ''
  //   UserModule.SetSysType(val)
  //   this.getCaptcha()
  // }

  private h5Url: any = ''
  private getDoain() {
    this.currentDomain = window.location.host
    this.jumpDoain = this.currentDomain.split('manage.')[1]
    // this.h5Url = 'h5.' + this.jumpDoain
    this.h5Url = `${'h5.' + this.jumpDoain}`
  }
  private jump() {
    window.open('https://' + this.h5Url)
  }

  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!isValidUsername(value)) {
      callback(new Error('Please enter the correct user name'))
    } else {
      callback()
    }
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('The password can not be less than 6 digits'))
    } else {
      callback()
    }
  }

  private validateCode = (rule: any, value: string, callback: Function) => {
    if (value.length <= 0) {
      callback(new Error('The captcha cannot be empty'))
    } else {
      callback()
    }
  }

  private loginForm = {
    username: '',
    code: '',
    password: ''
  }
  private loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
    code: [{ validator: this.validateCode, trigger: 'blur' }]
  }
  private captcha: captcha | any = {
    key: '',
    image: ''
  }
  private passwordType = 'password'
  private loading = false
  private showDialog = false
  private capsTooltip = false
  private redirect?: string
  private otherQuery: Dictionary<string> = {}

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }

  mounted() {
    if (this.loginForm.username === '') {
      ;(this.$refs.username as Input).focus()
    } else if (this.loginForm.password === '') {
      ;(this.$refs.password as Input).focus()
    }
    // this.getCaptcha()
    this.getDoain()
    if (this.isMobileH5) {
      this.dialogVisible = true
    }
  }
  create() {
    UserModule.SetSysType('payment')
  }

  // private async getCaptcha() {
  //   this.captcha = await getCaptcha()
  // }
  private checkCapslock(e: KeyboardEvent) {
    const { key } = e
    this.capsTooltip =
      key !== undefined &&
      key !== null &&
      key.length === 1 &&
      key >= 'A' &&
      key <= 'Z'
  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      ;(this.$refs.password as Input).focus()
    })
  }

  private handleLogin() {
    ;(this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      try {
        if (valid) {
          // this.loginForm.key = this.captcha.key
          this.loading = true
          await UserModule.Login(this.loginForm).then(() => {
            setTimeout(() => {
              this.loading = false
            }, 500)
          })
          await this.$router.push({
            path: '/enterpriseApp' || this.redirect,
            query: this.otherQuery
          })
          window.location.reload()
        } else {
          return false
        }
      } catch (e) {
        // this.getCaptcha()
      }
    })
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }
}
